export interface Tile {
  id: string;
  letter: string;
  points: number;
  isBlank: boolean;
  placedTurn?: number;
  isPinned?: boolean;
}

export const TILE_DISTRIBUTION_ES: { letter: string; points: number; count: number }[] = [
  { letter: '*', points: 0, count: 2 },
  { letter: 'A', points: 1, count: 12 },
  { letter: 'E', points: 1, count: 12 },
  { letter: 'O', points: 1, count: 9 },
  { letter: 'I', points: 1, count: 6 },
  { letter: 'S', points: 1, count: 6 },
  { letter: 'N', points: 1, count: 5 },
  { letter: 'R', points: 1, count: 5 },
  { letter: 'U', points: 1, count: 5 },
  { letter: 'L', points: 1, count: 4 },
  { letter: 'T', points: 1, count: 4 },
  { letter: 'D', points: 2, count: 5 },
  { letter: 'G', points: 2, count: 2 },
  { letter: 'C', points: 3, count: 4 },
  { letter: 'B', points: 3, count: 2 },
  { letter: 'M', points: 3, count: 2 },
  { letter: 'P', points: 3, count: 2 },
  { letter: 'H', points: 4, count: 2 },
  { letter: 'F', points: 4, count: 1 },
  { letter: 'V', points: 4, count: 1 },
  { letter: 'Y', points: 4, count: 1 },
  { letter: 'Q', points: 5, count: 1 },
  { letter: 'J', points: 8, count: 1 },
  { letter: 'Ñ', points: 8, count: 1 },
  { letter: 'X', points: 8, count: 1 },
  { letter: 'Z', points: 10, count: 1 },
];

export const createBag = (tileCount: number = 100): Tile[] => {
  const bag: Tile[] = [];
  const timestamp = Date.now();
  let idCounter = 0;
  
  const ratio = tileCount / 100;
  
  // Calculate counts based on ratio
  const adjustedDistribution = TILE_DISTRIBUTION_ES.map(item => ({
    ...item,
    count: Math.round(item.count * ratio)
  }));
  
  // Adjust total to match tileCount exactly
  let currentTotal = adjustedDistribution.reduce((sum, item) => sum + item.count, 0);
  
  // Simple adjustment: cycle through vowels (A, E, O, I, U)
  const vowels = ['A', 'E', 'O', 'I', 'U'];
  let diff = tileCount - currentTotal;
  let vowelIdx = 0;
  
  while (diff !== 0) {
    const vowelLetter = vowels[vowelIdx % vowels.length];
    const itemIdx = adjustedDistribution.findIndex(item => item.letter === vowelLetter);
    
    if (itemIdx !== -1) {
      if (diff > 0) {
        adjustedDistribution[itemIdx].count++;
        diff--;
      } else if (adjustedDistribution[itemIdx].count > 0) {
        adjustedDistribution[itemIdx].count--;
        diff++;
      }
    }
    vowelIdx++;
    
    // Safety break if we've cycled many times and can't adjust further
    if (vowelIdx > 1000) break;
  }

  adjustedDistribution.forEach(({ letter, points, count }) => {
    for (let i = 0; i < count; i++) {
      bag.push({
        id: `tile_${timestamp}_${idCounter++}_${Math.random().toString(36).substring(7)}`,
        letter,
        points,
        isBlank: letter === '*'
      });
    }
  });
  
  // Shuffle bag
  for (let i = bag.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [bag[i], bag[j]] = [bag[j], bag[i]];
  }
  
  return bag;
};
